import { cn } from '@latitude/token-utils';
import type { JSX } from 'react';

import type { SVGProps } from '../types';

const GalaxyIcon = ({
  title = 'Galaxy',
  className,
  ...restProps
}: SVGProps): JSX.Element => (
  <svg
    className={cn('fill-current', className)}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <title>{title}</title>
    <g clipPath="url(#galaxy-icon-clip)">
      <path d="M17.0638 2.95627H2.93832C6.85994 -0.984514 13.1403 -0.985684 17.0638 2.95627ZM2.93832 2.95627C-0.965069 6.87873 -0.993782 13.2445 2.93832 17.1494C2.9325 12.4192 2.94258 7.68694 2.93832 2.95627ZM17.0638 2.95627C17.0596 7.68655 17.0697 12.4188 17.0638 17.1494C20.9924 13.2465 20.9649 6.876 17.0638 2.95627ZM2.93832 17.149C2.93948 18.0988 2.93754 19.0502 2.93832 20H17.0638C17.0646 19.0502 17.0627 18.0988 17.0638 17.149H2.93832Z" />
    </g>
    <defs>
      <clipPath id="galaxy-icon-clip">
        <rect width="20" height="20" />
      </clipPath>
    </defs>
  </svg>
);

export { GalaxyIcon };
